import AddOnSection from "@components/new-ui/AddOnSection";
import AwardsSection from "@components/new-ui/AwardsSection";
import ClientLogos from "@components/new-ui/ClientLogos";
import { container_classname } from "@components/new-ui/constants";
import CTASection from "@components/new-ui/CTASection";
import FAQSection from "@components/new-ui/FAQSection";
import IntegrationSection from "@components/new-ui/IntegrationSection";
import NewLayout from "@components/new-ui/Layout";
import PricingSection from "@components/new-ui/PricingSection";
import PricingHeader from "@components/new-ui/PricingSection/PricingHeader";
import SpotlightSection2 from "@components/new-ui/SpotlightSection2";
import faqSchema from "components/faqSchema/pricing.json";
import Head from "next/head";
import React from "react";

const Pricing: React.FC = () => {
    return (
        <NewLayout
            title="WhatsApp Business API Pricing | Gallabox Pricing"
            description="Find the perfect WhatsApp Business API pricing plan for your growth needs. No hidden costs — know exactly what you're paying for."
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/pricing/pricing-og.png" }}
            canonical="https://gallabox.com/pricing"
        >
            <Head>
                <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
            </Head>
            <PricingHeader />
            <PricingSection />
            <IntegrationSection isLight={true} />
            <AddOnSection />
            <section className={`${container_classname} my-10`}>
                <h3 className="text-center text-lg font-normal py-5">Trusted by 10,000+ businesses</h3>
                <ClientLogos />
            </section>
            <SpotlightSection2 />
            <FAQSection />
            <AwardsSection />
            <CTASection title="Move your marketing and sales teams to the fast lane and accelerate your business growth" />
        </NewLayout>
    );
};

export default Pricing;
